import { PAYMENTS_SECTIONS_ROUTES } from '@/models/app-internal/permissions.model';
import { RouteComponent, RouteRecordRaw } from 'vue-router';

export const limitExceptionsUploadRoutes: RouteRecordRaw[] = [
  {
    name: PAYMENTS_SECTIONS_ROUTES.LIMIT_EXCEPTIONS_UPLOAD,
    path: `/${PAYMENTS_SECTIONS_ROUTES.LIMIT_EXCEPTIONS_UPLOAD}`,
    component: async (): Promise<RouteComponent> =>
      await import('@/layouts/limit-exceptions-upload-page/limit-exceptions-upload-page.vue'),
  },
];
